import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	companies: [],
	isLoading: false,
	error: false,
};

const companiesSlice = createSlice({
	name: 'companies',
	initialState,
	reducers: {
		storeCompanies: (state, action) => {
			state.companies = action.payload;
		},
	},
});

export const selectAllCompanies = (state) => {
	return state.companies;
};

export const { storeCompanies } = companiesSlice.actions;

export default companiesSlice.reducer;
